import { Select, SelectProps } from '@wegroup/design-system';
import { useAnvaCollectionMethods } from '@flows/src/api/anva-flows/getCollecitonMethods';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { useTranslation } from 'react-i18next';

interface Props {
  type?: 'POLICY' | 'PACKAGE';
}

const AnvaCollectionMethodSelectInput = ({
  type,
  isDisabled,
  ...selectProps
}: SelectProps & Props) => {
  const { t } = useTranslation();
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || '';
  const { data, isLoading } = useAnvaCollectionMethods(sessionId);

  const options =
    data?.items
      .filter(({ type: itemType }) => (type ? itemType === type : true))
      .map((item) => ({
        label: item.name,
        value: String(item.code),
      })) || [];

  return (
    <Select isDisabled={isLoading || isDisabled} {...selectProps}>
      <option value="">{t('Select an option')}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default AnvaCollectionMethodSelectInput;
